import appApi from "./api";

export const cotizacionUnidadMargenResidualService = {
  get() {
    return appApi().get("cotizaciones/unidad/margen/residual");
  },
};
